export const MOBILE_VIEW_CARD_ORDER_OPTIONS = [
  'CreatedAt',
  'DailyReturnPct',
  'QuarterPnl',
  'TotalReturnPct',
  'TotalPnl',
]

export const MOBILE_VIEW_CARD_ORDER_DIRECTIONS = ['ASC', 'DESC']
export const MOBILE_VIEW_CARD_ORDER_DEFAULT = 'CreatedAt/DESC'
